/* eslint-disable @typescript-eslint/no-explicit-any */
import { isNativeApp } from '../../../client'
import { getPpid } from '../../../utils'
import { resolveImaReferrer } from '../../../utils/imaReferrer'
import { AD_NETWORK } from './adUnits'

export const mediaCdn = 'https://media3.reshet.tv/image/upload/'

const liveEntriesRefs = {
  noCaptions: {
    e000: '1_ubg28z0w', //Israel_No_Subtitles_Web
    e010: '1_n3fizy37', //Global_No_Subtitles_Web
    e100: '1_x3xriuot', //Israel_No_Subtitles_Mobile
    e110: '1_l38msgjy', //Global_No_Subtitles_Mobile
  },
  captions: {
    e001: '1_8dlti2jz', //Israel_Subtitles_Web
    e011: '1_zb13i6jt', //Global_Subtitles_Web
    e101: '1_bkg2huh9', //Israel_Subtitles_Mobile
    e111: '1_elncycc8', //Global_Subtitles_Mobile
  },
}

const liveBBEntries = {
  noCaptions: {
    e000: '1_6fr5xbw2', //Israel_No_Subtitles_Web
    e010: '1_6fr5xbw2', //Global_No_Subtitles_Web
    e100: '1_6fr5xbw2', //Israel_No_Subtitles_Mobile
    e110: '1_6fr5xbw2', //Global_No_Subtitles_Mobile
  },
  captions: {
    e001: '1_6fr5xbw2', //Israel_Subtitles_Web
    e011: '1_6fr5xbw2', //Global_Subtitles_Web
    e101: '1_6fr5xbw2', //Israel_Subtitles_Mobile
    e111: '1_6fr5xbw2', //Global_Subtitles_Mobile
  },
}

export const subtitlesData = {
  video_accessibility_cookie_name: 'video_subtitles_enabled',
  video_accessibility_cookie_hour: 3, //3 hours
}

export const mode = {
  BB: 'BB',
  live: 'live',
}
export const video_ads_prefix = `https://pubads.g.doubleclick.net/gampad/ads?iu=${AD_NETWORK}`

const ad_correlator = () => Math.floor(Math.random() * 1e15) + Date.now()
const getDescriptionUrl = () =>
  typeof window !== 'undefined'
    ? encodeURIComponent(window.location.origin + window.location.pathname)
    : 'https%3A%2F%2F13tv.co.il%2F'

const TV_DEVICE_PATHS: Record<string, string> = {
  d: 'desktop/reshet',
  m: 'mweb/reshet',
  a: 'mapp/reshet',
}
const TV_AD_PATHS: Record<string, { path: string; vast?: true }> = {
  vod: { path: 'vod' },
  live_preroll: { path: 'live/preroll' },
  live_midroll: { path: 'live/midroll' },
  bb_preroll: { path: '26/preroll' },
  bb_midroll: { path: '26/midroll', vast: true },
}
const REELS_DEVICE_PATHS: Record<string, string> = {
  d: 'Vertical/Vertical_Desktop',
  m: 'Vertical/Vertical_Mobile',
  a: 'Vertical/Vertical_App',
}
/** RESH13-1138 - vertical video played on an item page, own units in the same family */
const ITEM_VERTICAL_DEVICE_PATHS: Record<string, string> = {
  d: 'Vertical/Vertical_DesktopItem',
  m: 'Vertical/Vertical_MobileItem',
  a: 'Vertical/Vertical_AppItem',
}

/** 13 Shorts: vertical and horizontal creatives (a horizontal one is letterboxed) */
const SHORTS_AD_SIZES = '640x480%7C1080x1920'

const videoAdUrl = (unitPath: string, sizes: string): string =>
  `${video_ads_prefix}/${unitPath}&ppid=${getPpid()}&description_url=${getDescriptionUrl()}&tfcd=0&npa=0&sz=${sizes}&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=${ad_correlator()}`

const verticalAdUrl = (
  devicePaths: Record<string, string>,
  vmapKey: string
): string => videoAdUrl(devicePaths[vmapKey.split('_')[0]], '1080x1920')
export const playerConfig: any = {
  liveEntries: {
    noCaptions: liveEntriesRefs.noCaptions,
    captions: liveEntriesRefs.captions,
  },

  liveBBEntries: {
    noCaptions: liveBBEntries.noCaptions,
    captions: liveBBEntries.captions,
  },
  DEFAULT_PLAYER: 1,
  INACTIVE_TIMEOUT: 1800000, // 30min
  NEW_DAY_TIMEOUT: 60 * 60 * 24 * 1000, //24h
  geo_cookie_name: 'r13_geo',
  MobileBreakPoint: 978,
  tvRed: null as any,
  VOD_MAIN_PLAYER: 'VOD_MAIN_PLAYER',
  DFPParams: {
    timer_BB: 8.25, //minutes
    timer_VOD: 8.25, //minutes
    refresh_timer: 60, // minutes
    DFP_ON: true,
    ADS_VIDEO: {
      tv: (vmapKey: string, videoDurationSec?: number): string => {
        const [device, ...rest] = vmapKey.split('_')
        const { path, vast } = TV_AD_PATHS[rest.join('_')]
        const unitPath = `${TV_DEVICE_PATHS[device]}/${path}`
        const referrer = resolveImaReferrer()
        const isLive = rest.includes('live')
        const vmapImaParams =
          !vast &&
          `&plcmt=1&hl=he&url=${getDescriptionUrl()}&vpa=click&vpmute=0${
            videoDurationSec != null && videoDurationSec > 0
              ? `&vid_d=${Math.round(videoDurationSec)}`
              : ''
          }${referrer ? `&ref=${encodeURIComponent(referrer)}` : ''}`
        return `${video_ads_prefix}/${unitPath}&ppid=${getPpid()}&description_url=${getDescriptionUrl()}&tfcd=0&npa=0&sz=640x480${
          vast ? '&max_ad_duration=45000' : vmapImaParams
        }&gdfp_req=1&unviewed_position_start=1&output=${
          vast
            ? 'vast'
            : 'vmap&ad_rule=1' +
              (isLive ? '&vad_type=linear' : '&cmsid=2546096')
        }&env=vp&impl=s&correlator=${ad_correlator()}${
          vast ? '&pmad=1&vpos=midroll&vpa=auto' : ''
        }`
      },
      reels: (vmapKey: string): string =>
        verticalAdUrl(REELS_DEVICE_PATHS, vmapKey),
      verticalItem: (vmapKey: string): string =>
        verticalAdUrl(ITEM_VERTICAL_DEVICE_PATHS, vmapKey),
      shorts: (unitPath: string): string =>
        videoAdUrl(unitPath, SHORTS_AD_SIZES),
    },
    ASEET_KEY: {
      Israel: {
        news: {
          d_key: 'g_-iak23ToK9O1PjuEVAzQ',
          m_key: 'P3CNpUG9TeKUgWZzSS4QIA',
          a_key: 'cj1lDSglQ7iQZPE80jKPTA',
        },
        tv: {
          d_key: 'OpZqIPuwR4md7SbGptVDFQ',
          m_key: 'jnzr1hxGTseHG3-_tQjsaA',
          a_key: '9Ci746QUTPOcPwIGUIfFSQ',
        },
      },
      Global: {
        news: {
          d_key: 'w1k4xmjmRJWqM2x35Yyljw',
          m_key: 'lR15zc-aRnalGvPqTgGbvA',
          a_key: 'Q-uNb1FHSIiPeXCwhFA0zA',
        },
        tv: {
          d_key: 'fDTiATvlRXuRyf_Wy-cOkw',
          m_key: 'aBQZr-teQlSKwVOgflncQg',
          a_key: 'KV9uTCDuT7CryS5SnlDa0A',
        },
      },
      Token: 'Mv8mqltnTEGZKwDp-VJxYw',
    },
  },
  inWebView: typeof window !== 'undefined' ? isNativeApp() : false,
  fakeWindow: {
    location: { href: '' },
    siteConfig: {
      default_images: {
        subtitleBtn: mediaCdn + 'v1643885178/assets/icons/ear.png',
        subtitleBtnIcons: {
          on: mediaCdn + 'v1645538480/uploads/2022/860397.png',
          off: mediaCdn + 'v1645538478/uploads/2022/860396.png',
        },
        tv: {
          default_image: mediaCdn + 'v1750236296/assets/2025/default.webp',
          ad_block: mediaCdn + 'v1669283043/assets/2023/Adblock.webp',
          unavailable: mediaCdn + 'v1633341901/assets/2021/13_Unavailable.webp',
          overseas: mediaCdn + 'v1633341901/assets/2021/13_Overseas.webp',
          logo_horizontal: mediaCdn + 'v1638175012/assets/2021/RESHET13.webp',
          logo_on_black:
            mediaCdn +
            'v1633506608/assets/2021/Logo_horizontal_for_header_on_black.webp',
        },
        news: {
          default_image:
            mediaCdn + 'v1633341900/assets/2021/default_image_news.webp',
          ad_block: mediaCdn + 'v1669283043/assets/2023/Adblock.webp',
          unavailable:
            mediaCdn + 'v1633341900/assets/2021/News_Unavailable.webp',
          overseas: mediaCdn + 'v1633341900/assets/2021/News_Overseas.webp',
          logo_horizontal:
            mediaCdn + 'v1632992987/assets/2021/logo_horizontal.webp',
          logo_on_black:
            mediaCdn +
            'v1633506608/assets/2021/Logo_horizontal_for_header_on_black.webp',
        },
      },
      liveRefId: {
        stream_reshet_live1_dvr: {
          mod: mode.live,
          ch: 1,
          kantar: 1,
          entries: liveEntriesRefs.noCaptions,
        },
        stream_reshet_live1: {
          mod: mode.live,
          ch: 1,
          kantar: 1,
          entries: liveEntriesRefs.noCaptions,
        },
        stream_reshet_live1_captions: {
          mod: mode.live,
          ch: 27,
          kantar: 1,
          entries: liveEntriesRefs.captions,
        },
        stream_reshet_live1_dvr_captions: {
          mod: mode.live,
          ch: 27,
          kantar: 1,
          entries: liveEntriesRefs.captions,
        },
        stream_reshet_bb01: {
          mod: mode.BB,
          ch: 26,
          entries: liveBBEntries.noCaptions,
        }, //big brother
        stream_reshet_bb01_captions: {
          mod: mode.BB,
          ch: 27,
          entries: liveBBEntries.captions,
        }, //big brother
        bigbrother_live_drm_2023: {
          mod: mode.BB,
          ch: 27,
          entries: liveBBEntries.captions,
        },
        bigbrother_live_2023: {
          mod: mode.BB,
          ch: 27,
          entries: liveBBEntries.captions,
        },
      } as const,
      kaltura: {
        partnerId: '2748741',
        uiConfId: '50272542',
        vastLoadTimeout: 15000,
        mobileAutoplayChrome: true,
        geoLocation: {
          defaultGeoResponse: {
            country: 'Israel',
            ip: null,
          },
          default_cookie_days: 14,
          cookie_days: 7,
        },
        video_accessibility_cookie_hour: 3, //3 hours
        cdn: {
          kalturaCdn:
            'https://cdnapisec.kaltura.com/p/2748741/embedPlaykitJs/uiconf_id/50272542',
          akamaiCdn: '//akamai.advsnx.net/CDN/sdk/plugins/kaltura/plugin.js',
          kantarCdn:
            'https://13tv.co.il/wp-content/themes/reshet_tv/build/third-party/playkit/playkit-kantar.js',
        },
        plugin: {
          kaltura: 'kaltura',
          akamai: 'akamai',
          kantar: 'kantar',
          ima: 'ima',
          imadai: 'imadai',
        },
      },
      kantar_site_name: null,
      adds: { dayViewMaxCount: 5 },
    },
    activePlayer: null as any as HTMLElement,
    refreshTimeOut: null as any as number,
    analiticsInterval: null as any as number,
    videoStore: null as any as { [key: string]: any },
    thirdParty: {
      kantar: false, //TODO: window.location.search.includes("kantar=on") || document.cookie.indexOf("kantarInit=true") >= 0 ,
    },
  },
  gtag_id_prod: 'UA-985873-3',
  gtag_id_testing: 'G-QMEX2YL2K2',
}
export const default_player_progress_report_map = [0.25, 0.5, 0.75, 0.9]
